import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { ConfigurationService } from '@/common/services/configuration/configuration.service';
import { SummaryService } from '@/common/services/summary/summary.service';

@Component({
  selector: 'fe-review-reserve',
  templateUrl: './review-reserve.component.html',
  styleUrls: ['./review-reserve.component.scss']
})
export class ReviewReserveComponent {

  @Input() formPersonalInfo!: FormGroup;
  @Input() checkBoxs: any;
  @Input() loadingBtnReservate: boolean = false;
  @Input() formBBVA: any;
  @Input() urlActionBBVA!: string;
  @Input() successUrl!: string;
  @Input() errorUrl!: string;
  @Input() marginTop: number = 0;

  @Output() reservateClick = new EventEmitter<void>();
  @Output() onlyLettersKeypress = new EventEmitter<KeyboardEvent>();

  @ViewChild('btnReservate') btnReservate!: ElementRef;

  constructor(
    public reservation: CurrentReservationService,
    public configuration: ConfigurationService,
    public summaryService: SummaryService
  ) {}

  get savings(): number {
    return this.summaryService.summary?.discount ?? 0;
  }

  get isLite(): boolean {
    return this.summaryService.isLite;
  }

  getOfficeSubtitleKey(): string {
    return this.isLite
      ? 'fe_step4_complete_reservation_div_subtitle_office_lite'
      : 'fe_step4_complete_reservation_div_subtitle_office';
  }

  getProtectionNoticeTextKey(): string {
    return this.reservation.current.flowType === 'office'
      ? 'fe_step4_protection_notice_text_office'
      : 'fe_step4_protection_notice_text';
  }

  getPrepaidSubtitleKey(): string {
    return this.isLite
      ? 'fe_step4_complete_reservation_div_subtitle_prepaid_lite'
      : 'fe_step4_complete_reservation_div_subtitle_prepaid';
  }

  onClicReservate(): void {
    this.reservateClick.emit();
  }

  onlyLetters(event: KeyboardEvent): void {
    this.onlyLettersKeypress.emit(event);
  }
}
